import { render } from "./VODUploadWidgetLight.vue?vue&type=template&id=73403726&scoped=true"
import script from "./VODUploadWidgetLight.vue?vue&type=script&lang=js"
export * from "./VODUploadWidgetLight.vue?vue&type=script&lang=js"

import "./VODUploadWidgetLight.vue?vue&type=style&index=0&id=73403726&scoped=true&lang=css"
import "./VODUploadWidgetLight.vue?vue&type=style&index=1&id=73403726&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73403726"]])

export default __exports__